export function getStoredPermissions(): Record<string, string[]> {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return {}
  }

  const data = localStorage.getItem('permissions')
  return data ? JSON.parse(data) : {}
}
